module.exports = "<div id=\"social-icons\">\n  <h3>Follow Us On Social Media</h3>\n  <a href=\"https://www.facebook.com/massahcollection/\" class=\"fa fa-facebook\"></a>\n  <a href=\"https://twitter.com/massahco\" class=\"fa fa-twitter\"></a>\n  <a href=\"https://www.instagram.com/massahc/\" class=\"fa fa-instagram\"></a>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/structural_components/footer/social-icons/social-icons.component.html
// module id = 415
// module chunks = 1